import { useCallback } from 'react';
import { useSiteContext } from '../SiteContext';
import { getPayPeriodDate } from './usePayPeriods';
import { PayPeriod } from '../interfaces/PayPeriodInterface';

/**
 * The single write path for "the app is now on this week".
 *
 * SiteContext keeps the selected period spread across five fields (week, year,
 * payPeriodID, startDate, endDate) that every consumer expects to move together —
 * so anything that changes the week has to set all five. The header week pill owns
 * this normally; pages that can jump weeks from inside their own UI (e.g. clicking a
 * bar on the Project Work trend chart) call this rather than re-deriving the block.
 */
export function useSelectPayPeriod(): (payPeriod: PayPeriod) => void {
  const { setWeek, setYear, setPayPeriodID, setStartDate, setEndDate } = useSiteContext();

  return useCallback(
    (pp: PayPeriod) => {
      setWeek(pp.WeekNumber);
      setYear(String(pp.AccountingYear));
      setPayPeriodID(pp.PayPeriodID);
      setStartDate(getPayPeriodDate(new Date(pp.StartDate)));
      setEndDate(getPayPeriodDate(new Date(pp.EndDate)));
    },
    [setWeek, setYear, setPayPeriodID, setStartDate, setEndDate]
  );
}

export default useSelectPayPeriod;
